import React, { useState, useEffect } from "react";
import { useUser } from "reactfire";
import { useHistory } from "react-router-dom";
import { httpsCallable } from "firebase/functions";
import { useTranslation } from "react-i18next";
import { useLeague } from "context/leagueContext";
import { useGame } from "context/gameContext";
import { useFunctions } from "reactfire";
import {
  IonContent,
  IonItem,
  IonLabel,
  IonAlert,
  IonList,
  IonListHeader,
  IonRow,
  IonCol,
  IonAvatar,
  IonPopover,
} from "@ionic/react";
import { useFirestore, useFirestoreDocData } from "reactfire";
import { doc } from "firebase/firestore";
import { Md2InformationSlabCircleOutline } from "react-icons-ng/md2";
import { showToast } from "utils/utils";
const TournamentInfo = () => {
  const {
    state: { leagueInfo, tournamentInfo, leagueUserData },
  } = useLeague();

  const {
    state: { settings },
    dispatch,
  } = useGame();

  const [isLoading, setIsLoading] = useState(false);

  const { status, data: user } = useUser();
  const { t } = useTranslation();

  const { gameType, gameTypeId } = leagueInfo;

  const firestore = useFirestore();
  const [userAdminData, setUserAdminData] = useState(undefined);

  const leagueAdminRef = doc(
    firestore,
    "userTournaments/" + leagueInfo?.id + "/users/",
    leagueInfo?.admin
  );
  const { status: userRoundDataStatus, data: leagueAdminDoc } =
    useFirestoreDocData(leagueAdminRef);
  useEffect(() => {
    if (leagueAdminDoc) {
      setUserAdminData(leagueAdminDoc);
    }
  }, [leagueAdminDoc]);

  //let navigate = useNavigate();
  const history = useHistory();

  const functions = useFunctions();
  const removeFromLeagues = httpsCallable(functions, "removeUserFromLeague", {
    timeout: 530000,
  });

  const removeLeague = httpsCallable(functions, "deleteUserLeague", {
    timeout: 530000,
  });

  const callRemoveFromLeague = async () => {
    if (!user.uid) return;
    setIsLoading(true);

    let data = {
      userId: user.uid,
      leagueId: leagueInfo?.id,
    };

    removeFromLeagues(data)
      .then((result) => {
        const data = result.data;
        const sanitizedMessage = data?.text;
        setIsLoading(false);
        history.push("/");
        //navigate("/");
      })
      .catch((error) => {
        const code = error.code;
        const message = error.message;
        const details = error.details;
        setIsLoading(false);
      });
  };

  const callDeleteLeague = async () => {
    if (!user.uid) return;
    setIsLoading(true);

    let data = {
      visible: false,
      userId: user.uid,
      leagueId: leagueInfo?.id,
    };

    removeLeague(data)
      .then((result) => {
        const data = result.data;
        const sanitizedMessage = data?.text;
        setIsLoading(false);
        history.push("/");
        //navigate("/");
      })
      .catch((error) => {
        const code = error.code;
        const message = error.message;
        const details = error.details;
        setIsLoading(false);

        showToast(t("Something went wrong. Please try again"), "success");
      });
  };

  const isPastDeadline =
    new Date(leagueInfo?.deadline?.seconds * 1000) < new Date();

  return (
    <IonList className="rounded-md">
      <IonListHeader mode="ios">
        <IonLabel>{t("tournament.info.info_header")}</IonLabel>
      </IonListHeader>
      <IonItem>
        <IonLabel>
          <h3>{t("common.gametypes.header_type")}</h3>
          <p>
            {" "}
            {gameType == 0
              ? t("common.gametypes.season")
              : t("common.gametypes.playoff")}
          </p>
        </IonLabel>
      </IonItem>
      <IonItem button id="click-trigger">
        <IonLabel>
          <h3>{t("common.gametypes.header_mode")}</h3>
          <p>
            {gameTypeId !== undefined
              ? t(
                  "createTournament.steps.setSelectedGame.types.titles." +
                    gameTypeId
                )
              : "-"}
          </p>
        </IonLabel>
        <Md2InformationSlabCircleOutline className="h-6 w-6" slot="end" />
      </IonItem>
      <IonPopover trigger="click-trigger" triggerAction="click" alignment="end">
        <IonContent class="!p-2">
          <div className="flex flex-col text-sm items-center justify-center p-2">
            {gameTypeId !== undefined
              ? t(
                  "createTournament.steps.setSelectedGame.types.descriptions." +
                    gameTypeId
                )
              : "-"}
          </div>
        </IonContent>
      </IonPopover>
      <IonItem>
        <IonLabel>
          <h3>{t("common.league")}</h3>
          <p>
            {tournamentInfo?.leagueName &&
              tournamentInfo?.country_name +
                " - " +
                tournamentInfo?.leagueName +
                " (" +
                tournamentInfo?.name +
                ")"}
          </p>
        </IonLabel>
      </IonItem>
      <IonRow>
        <IonCol col-3 className="p-0">
          <IonItem>
            <IonLabel>
              <h3>{t("common.start_date")}</h3>
              <p>
                {leagueInfo?.deadline &&
                  new Date(leagueInfo?.deadline?.seconds * 1000).toLocaleString(
                    undefined,
                    {
                      month: "short",
                      day: "2-digit",
                      hour: "2-digit",
                      hour12: false,
                      minute: "2-digit",
                    }
                  )}
              </p>
            </IonLabel>
          </IonItem>
        </IonCol>
        {gameType == 0 && (
          <IonCol col-3 className="p-0">
            <IonItem>
              <IonLabel>
                <h3>{t("common.end_date")}</h3>
                <p>
                  {leagueInfo?.endingAt &&
                    new Date(
                      leagueInfo?.endingAt?.seconds * 1000
                    ).toLocaleString(undefined, {
                      month: "short",
                      day: "2-digit",
                      hour: "2-digit",
                      hour12: false,
                      minute: "2-digit",
                    })}
                </p>
              </IonLabel>
            </IonItem>
          </IonCol>
        )}
      </IonRow>
      {gameType == 0 && (
        <IonItem>
          <IonLabel>
            <h3>{t("common.length")}</h3>
            <p>
              {leagueInfo?.rounds &&
                Object.keys(leagueInfo?.rounds) &&
                t("common.round_length", {
                  count: Object.keys(leagueInfo?.rounds).length,
                })}
            </p>
          </IonLabel>
        </IonItem>
      )}
      <IonItem>
        <IonAvatar slot="start">
          <img alt="User avatar" src={userAdminData?.photo} />
        </IonAvatar>
        <IonLabel>
          <h3>{t("tournament.info.admin")}</h3>
          <p>{userAdminData?.userName && userAdminData?.userName}</p>
        </IonLabel>
      </IonItem>
      {leagueInfo?.scoreRule != 5 && (
        <IonListHeader mode="ios">
          <IonLabel>{t("tournament.info.rules")}</IonLabel>
        </IonListHeader>
      )}
      {(leagueInfo?.gameRule == 0 ||
        (leagueInfo?.gameRule === 4 && leagueInfo?.scoreRule === 1)) && (
        <IonItem>
          <IonLabel>
            <h3>{t("common.boosts")}</h3>
            <p>{leagueInfo?.boosts}x</p>
          </IonLabel>
        </IonItem>
      )}
      {(leagueInfo?.scoreRule === 4 ||
        leagueInfo?.scoreRule === 6 ||
        leagueInfo?.scoreRule === 8) && (
        <IonItem>
          <IonLabel>
            <h3>{t("common.gamerules.startingBalance")}</h3>
            <p>{leagueInfo?.startingBalance}</p>
          </IonLabel>
        </IonItem>
      )}
      {(leagueInfo?.scoreRule === 6 ||
        (leagueInfo?.gameRule === 4 && leagueInfo?.scoreRule === 0)) && (
        <IonItem>
          <IonLabel>
            <h3>{t("common.gamerules.minCorrectRule")}</h3>
            <p>{leagueInfo?.minCorrectRule}</p>
          </IonLabel>
        </IonItem>
      )}
      {leagueInfo?.gameRule === 4 && leagueInfo?.scoreRule === 1 && (
        <IonItem>
          <IonLabel>
            <h3>{t("common.gamerules.eliminationRate")}</h3>
            <p>{leagueInfo?.eliminationRate}%</p>
          </IonLabel>
        </IonItem>
      )}
      {((leagueInfo?.gameType == 0 && leagueInfo?.scoreRule != 8) ||
        leagueInfo?.gameRule === 4) && (
        <IonItem>
          <IonLabel>
            <h3>{t("common.gamerules.eliminationRate")}</h3>
            <p>{leagueInfo?.allWinBonus}p</p>
          </IonLabel>
        </IonItem>
      )}
      {(leagueInfo?.scoreRule === 3 || leagueInfo?.scoreRule === 4) && (
        <>
          <IonItem>
            <IonLabel>
              <h3>{t("common.gamerules.fullEventCorrect")}</h3>
              <p>{leagueInfo?.fullEventCorrect}p</p>
            </IonLabel>
          </IonItem>
          <IonItem>
            <IonLabel>
              <h3>{t("common.gamerules.fullEventCorrect")}</h3>
              <p>{leagueInfo?.partialEventCorrect}p</p>
            </IonLabel>
          </IonItem>
        </>
      )}
      {(!isPastDeadline || !leagueInfo?.settled) && (
        <IonListHeader mode="ios">
          <IonLabel>{t("tournament.info.actions")}</IonLabel>
        </IonListHeader>
      )}
      {user?.uid == leagueInfo?.admin && !isPastDeadline && (
        <IonItem button detail="true" id="present-alert">
          <IonLabel>{t("tournament.info.delete.title")}</IonLabel>

          <IonAlert
            header={t("tournament.info.delete.info")}
            trigger="present-alert"
            buttons={[
              {
                text: t("common.cancel"),
                role: "cancel",
              },
              {
                text: t("common.confirm"),
                role: "confirm",
                handler: () => {
                  callDeleteLeague();
                },
              },
            ]}
          ></IonAlert>
        </IonItem>
      )}
      {user?.uid != leagueInfo?.admin && !leagueInfo?.settled && (
        <IonItem button detail="true" id="present-alert">
          <IonLabel>{t("tournament.info.leave.title")}</IonLabel>

          <IonAlert
            header={t("tournament.info.leave.info")}
            trigger="present-alert"
            buttons={[
              {
                text: t("common.cancel"),
                role: "cancel",
              },
              {
                text: t("common.confirm"),
                role: "confirm",
                handler: () => {
                  callRemoveFromLeague();
                },
              },
            ]}
          ></IonAlert>
        </IonItem>
      )}
    </IonList>
  );
};

export default TournamentInfo;
